/* tslint:disable */
/* eslint-disable */
/**
 * livechat
 * livechat API
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ChatMessageCreate } from '../models';
// @ts-ignore
import type { ChatMessageOut } from '../models';
// @ts-ignore
import type { HTTPValidationError } from '../models';
/**
 * ChatMessageApi - axios parameter creator
 * @export
 */
export const ChatMessageApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Insert a new chat message into the history for a given session ID.
         * @param {ChatMessageCreate} chatMessageCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addChatMessage: async (chatMessageCreate: ChatMessageCreate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'chatMessageCreate' is not null or undefined
            assertParamExists('addChatMessage', 'chatMessageCreate', chatMessageCreate)
            const localVarPath = `/api/v1/chat_history`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(chatMessageCreate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieve the full chat history for a given session ID, ordered by timestamp (ascending).
         * @param {string} sessionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getChatHistory: async (sessionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sessionId' is not null or undefined
            assertParamExists('getChatHistory', 'sessionId', sessionId)
            const localVarPath = `/api/v1/chat_history/{session_id}`
                .replace(`{${"session_id"}}`, encodeURIComponent(String(sessionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ChatMessageApi - functional programming interface
 * @export
 */
export const ChatMessageApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ChatMessageApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Insert a new chat message into the history for a given session ID.
         * @param {ChatMessageCreate} chatMessageCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addChatMessage(chatMessageCreate: ChatMessageCreate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChatMessageOut>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addChatMessage(chatMessageCreate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChatMessageApi.addChatMessage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Retrieve the full chat history for a given session ID, ordered by timestamp (ascending).
         * @param {string} sessionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getChatHistory(sessionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ChatMessageOut>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getChatHistory(sessionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChatMessageApi.getChatHistory']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ChatMessageApi - factory interface
 * @export
 */
export const ChatMessageApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ChatMessageApiFp(configuration)
    return {
        /**
         * 
         * @summary Insert a new chat message into the history for a given session ID.
         * @param {ChatMessageApiAddChatMessageRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addChatMessage(requestParameters: ChatMessageApiAddChatMessageRequest, options?: RawAxiosRequestConfig): AxiosPromise<ChatMessageOut> {
            return localVarFp.addChatMessage(requestParameters.chatMessageCreate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retrieve the full chat history for a given session ID, ordered by timestamp (ascending).
         * @param {ChatMessageApiGetChatHistoryRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getChatHistory(requestParameters: ChatMessageApiGetChatHistoryRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<ChatMessageOut>> {
            return localVarFp.getChatHistory(requestParameters.sessionId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for addChatMessage operation in ChatMessageApi.
 * @export
 * @interface ChatMessageApiAddChatMessageRequest
 */
export interface ChatMessageApiAddChatMessageRequest {
    /**
     * 
     * @type {ChatMessageCreate}
     * @memberof ChatMessageApiAddChatMessage
     */
    readonly chatMessageCreate: ChatMessageCreate
}

/**
 * Request parameters for getChatHistory operation in ChatMessageApi.
 * @export
 * @interface ChatMessageApiGetChatHistoryRequest
 */
export interface ChatMessageApiGetChatHistoryRequest {
    /**
     * 
     * @type {string}
     * @memberof ChatMessageApiGetChatHistory
     */
    readonly sessionId: string
}

/**
 * ChatMessageApi - object-oriented interface
 * @export
 * @class ChatMessageApi
 * @extends {BaseAPI}
 */
export class ChatMessageApi extends BaseAPI {
    /**
     * 
     * @summary Insert a new chat message into the history for a given session ID.
     * @param {ChatMessageApiAddChatMessageRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatMessageApi
     */
    public addChatMessage(requestParameters: ChatMessageApiAddChatMessageRequest, options?: RawAxiosRequestConfig) {
        return ChatMessageApiFp(this.configuration).addChatMessage(requestParameters.chatMessageCreate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retrieve the full chat history for a given session ID, ordered by timestamp (ascending).
     * @param {ChatMessageApiGetChatHistoryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatMessageApi
     */
    public getChatHistory(requestParameters: ChatMessageApiGetChatHistoryRequest, options?: RawAxiosRequestConfig) {
        return ChatMessageApiFp(this.configuration).getChatHistory(requestParameters.sessionId, options).then((request) => request(this.axios, this.basePath));
    }
}

